/**
 * Objeto de configuração do Chart iDS
 *
 * @category Components
 * */
export const IDS_CHART_CONFIG = {
  /** Border radius nos marcadores da legenda */
  marker_radius: 4,
  /** Largura dos marcadores da legenda */
  marker_width: 8,
  /** Altura dos marcadores da legenda */
  marker_height: 8,
  /** Opacidade das cores dos gráficos */
  color_opacity: 1,
  /** Gap entre o marcador e a label da legenda */
  legend_item_gap: -4,
  /** Margin lateral dos itens da legenda */
  legend_item_margin: 8,
  /** Gap entre as colunas no gráfico multi colunas */
  multi_column_gap: 1,
  /** Fonte utilizada no Chart */
  font_family: 'Itau Text',
  /** Shadow das labels de data */
  drop_shadow: 0,
  /** Espessura da linha do gráfico de linha e area */
  line_thickness: 1,
  /** Espessura do Donut */
  donut_thickness: '72%',
  /** Cor do grid */
  grid_color: 'var(--ids_color_border_soft)',
  /** Desabilita o menu hamburger */
  menu: false,
  /** Cor 01 do gráfico */
  color_01: 'var(--ids_color_chart_01)',
  /** Cor 02 do gráfico */
  color_02: 'var(--ids_color_chart_02)',
  /** Cor 03 do gráfico */
  color_03: 'var(--ids_color_chart_03)',
  /** Cor 04 do gráfico */
  color_04: 'var(--ids_color_chart_04)',
  /** Cor 05 do gráfico */
  color_05: 'var(--ids_color_chart_05)',
  /** Cor 06 do gráfico */
  color_06: 'var(--ids_color_chart_06)',
  /** Cor 07 do gráfico */
  color_07: 'var(--ids_color_chart_07)',
  /** Cor 08 do gráfico */
  color_08: 'var(--ids_color_chart_08)',
  /** Cor das legendas do gráfico */
  legend_color: 'var(--ids_color_action_neutral_base)',
  /** Cor das labels do gráfico */
  label_color: 'var(--ids_color_action_neutral_base)',
  /** Cor do título do gráfico */
  title_color: 'var(--ids_color_action_neutral_base)',
  /** Cor de fundo */
  background_color: 'var(--ids_color_bg_base)',
};
